function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "my vector image");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Layer 1");

var SvgStamperPusher = function SvgStamperPusher(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52.581196804131636,
    height: 63.61538561859231,
    viewBox: "0 0 52.581196804131636 63.61538561859231",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    className: "currentLayer"
  }, _ref3, /*#__PURE__*/React.createElement("rect", {
    fill: "#dadada",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDashoffset: "",
    fillRule: "nonzero",
    id: "svg_1",
    x: 22.743589639663696,
    y: 3.1794870495796204,
    width: 10,
    height: 52,
    style: {
      color: "rgb(210, 180, 140)"
    },
    className: "",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d2b48c",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDashoffset: "",
    fillRule: "nonzero",
    id: "svg_3",
    x: 19,
    y: 68,
    width: 26,
    height: 0,
    style: {
      color: "rgb(210, 180, 140)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#dadada",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDashoffset: "",
    fillRule: "nonzero",
    id: "svg_5",
    x: 2.034187912940979,
    y: 55.17948704957962,
    width: 50,
    height: 8,
    style: {
      color: "rgb(210, 180, 140)"
    },
    className: "",
    fillOpacity: 1
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStamperPusher, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stamper-pusher.1dbeb510.svg";
export { ForwardRef as ReactComponent };